import { ChartOptions } from 'chart.js';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { BunchesByKey } from '../../../../types/busBunchingTypes';

const chartSettings = {
    labels: [] as string[],
    datasets: [
        {
            data: [] as number[],
            backgroundColor: '#42DCC6',
        },
    ],
};

const options: ChartOptions<'bar'> = {
    scales: {
        x: {
            grid: {
                drawOnChartArea: false,
            },
        },
        y: {
            grid: {
                drawOnChartArea: false,
            },
            title: {
                display: true,
                text: 'Number of buched vehicles',
            },
        },
    },
    responsive: true,
    plugins: {
        title: {
            display: false,
        },
        legend: {
            display: false,
        },
        tooltip: {
            callbacks: {
                label: function (tooltipItem) {
                    return `Bunches: ${tooltipItem.parsed.y}`;
                },
            },
        },
    },
};

const BunchesByRoutesChart: React.FC<{ chartData: BunchesByKey[] }> = ({ chartData }) => {
    const [dataState, setDataState] = useState(chartSettings);

    useEffect(() => {
        const orderedData = chartData.sort((a, b) => (a.bunchesCount < b.bunchesCount) ? 1 : -1);
        const labels = orderedData.map(d => d.key);
        const values = orderedData.map(d => d.bunchesCount);

        setDataState(prevState => ({
            ...prevState,
            labels: labels,
            datasets: [{
                ...prevState.datasets[0],
                data: values,
            }],
        }));
    }, [chartData]);

    return (
        <Bar
            data={dataState}
            height={70}
            options={options}
        />
    );
};

export default BunchesByRoutesChart;